import React, { useState, useEffect, useContext } from 'react'
import config from '../../config'
import './IndexCss.css'
import Coffee from '../Icons/Coffee'
import Dinnerware from '../Icons/Dinnerware'
import BindIcon from '../Icons/BindIcon'
import intl from 'react-intl-universal'
import { Session } from '../../contexts/Session'
import { HospitalBasicInfoContext } from '../../contexts/HospitalBasicInfo'
import qs from 'querystring'
import { LanguageContext } from '../../contexts/LanguageContext'
// import { OrderMarkContext } from '../../contexts/OrderMark'
import request from '../../utils/request'
// import { Toast } from 'antd-mobile'
// import {
//   getHispitalInfo,
//   getAllFoodType,
//   isObjEmpty
// } from '../Order/OrderFunction'
import MyModal from '../myComponents/MyModal/MyModal'

function getCodeFromLocation (location) {
  const href = location.href
  const qs1 = qs.parse(href.substring(href.indexOf('?') + 1))
  return qs1.code
}

export default function Index (props) {
  // const sdxUserToken = window.localStorage.getItem('sdxUserToken')
  const SessionContext = useContext(Session)
  const Language = useContext(LanguageContext)
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext)
  const [hospitalInfo, setHospitalInfo] = useState(HospitalBasicInfo)
  const [registered, setRegistered] = useState(true)
  const [binded, setBinded] = useState(true)
  const [welcomeText, setWelcomeText] = useState('')
  const [showLogo, setShowLogo] = useState(false)
  const [isHospitalInfo, setIsHospitalInfo] = useState(false) // 医院是否存在
  const [showIndexPage, setShowIndexPage] = useState(false) // 是否展示首页
  // const OrderMark = useContext(OrderMarkContext)
  // const sdxHisCode = props.match.params.hisCode
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容

  // const [showPage, setShowPage] = useState(false)

  useEffect(() => {
    setHospitalInfo(HospitalBasicInfo.hospitalBasicInfo)
    if(HospitalBasicInfo && HospitalBasicInfo.hospitalBasicInfo && HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo){
      if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties) {
        setShowLogo(HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.showLogo)
      } else {
        setShowModal(true)
        setModalInfo(intl.get('The hospital configuration information is missing'))
      }
    }
  }, [HospitalBasicInfo])

  useEffect(() => {
    setRegistered(SessionContext.tokenExist)
    setBinded(SessionContext.binded)
  }, [SessionContext.tokenExist, SessionContext.binded])

  useEffect(() => {
    if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo) {
      if (Language.locale === 'zh') {
        setWelcomeText(HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.welcomeMessageZh)
      } else {
        setWelcomeText(HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.welcomeMessageEn)
      }
    }
  }, [Language.locale, HospitalBasicInfo])

  useEffect(() => {
    // console.log('进入页面')
    function saveHisCode () {
      window.localStorage.setItem('sdxHisCode', props.match.params.hisCode) // 当前医院hisCode
    }

    function savePatPositionId () {
      if (props.match.params.patPositionId) {
        window.localStorage.setItem('sdxPatPositionId', props.match.params.patPositionId) // 如果路由里包含床位号，就保存到localStorage里
      } else {
        if (window.localStorage.getItem('sdxPatPositionId')) {
          window.localStorage.removeItem('sdxPatPositionId') // 如果路由里不包含床位号，但是localStorage里有床位号，就删除localStorage里的床位号
        }
      }
    }
    const sdxUUID = window.localStorage.getItem('sdxUUID')
    if (window.localStorage.getItem('sdxPatPositionId')) {
      window.localStorage.removeItem('sdxPatPositionId')
    }
    if (window.localStorage.getItem('sdxHisCode')) {
      window.localStorage.removeItem('sdxHisCode')
    }
    if (window.location.href.indexOf('?code=') === -1) { // 用户首次进入index页面，区别于重定向回来的index页面
      // ========== 【新增】在重定向之前，先保存 source 参数 ==========
      const search = props.location.search || ''
      const urlParams = new URLSearchParams(search)
      const source = urlParams.get('source')
      if (source) {
        sessionStorage.setItem('order_source', source)
      } else { 
        sessionStorage.removeItem('order_source')
      }
      // ========== 【新增结束】==========

      if (sdxUUID) { // 本地保存了sdxUUID
        ifUUIDExpire(sdxUUID) // 判断sdxUUID是否过期
      } else { // 本地没有保存过uuid
        redirectToAuth() // 首先跳转微信授权页面获取UUID
      }
    } else { // 用户被重定向回到index页面或者用户点击返回首页
      // console.log('授权页跳回或用户点击返回')
      saveHisCode()
      savePatPositionId()
      if (sdxUUID) { // 本地保存了sdxUUID
        ifUUIDExpire(sdxUUID) // 判断sdxUUID是否过期
      } else { // 本地没有保存过uuid
        const code = getCodeFromLocation(window.location)
        getUUIDByCode(code)
      }
    }
  }, [])

  /**
   * 判断uuid是否过期
   */
  async function ifUUIDExpire (sdxUUID) {
    try {
      let res = await fetch(`${config.server}/v1/hospitals/${props.match.params.hisCode}`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Accept-Language': Language.acceptLanguage,
          UUID: sdxUUID
        }
      })
      if (res.status === 400) {
        res = await res.json()
        const error = new Error()
        error.raw = res
        error.code = res.code
        error.message = res.message
        throw error
      }
      window.localStorage.setItem('sdxHisCode', props.match.params.hisCode) // 当前医院hisCode
      if (props.match.params.patPositionId) {
        window.localStorage.setItem('sdxPatPositionId', props.match.params.patPositionId) // 如果路由里包含床位号，就保存到localStorage里
      } else {
        if (window.localStorage.getItem('sdxPatPositionId')) {
          window.localStorage.removeItem('sdxPatPositionId') // 如果路由里不包含床位号，但是localStorage里有床位号，就删除localStorage里的床位号
        }
      }
      beforeGetUserTokenByUUID(sdxUUID)
    } catch (e) {
      window.localStorage.removeItem('sdxUUID')
      if (e.code && Number(e.code) === 1001) {
        setIsHospitalInfo(false)
        setShowIndexPage(false)
        setShowModal(true)
        setModalInfo(e.message)
      } else if (e.code && Number(e.code) === 2000) {
        setIsHospitalInfo(false)
        setShowIndexPage(false)
        redirectToAuth()
      }
    }
  }
  /**
   * 重定向到微信授权页面
   */
  function redirectToAuth () {
    window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=%23${props.location.pathname}`)
    // window.location.replace(`${config.server}/v1/wxcommons/oauth2?return_url=${props.location.pathname}`)
  }

  /**
   * 根据code获取uuid
   */
  async function getUUIDByCode (code) {
    // console.log('根据code获取uuid')
    try {
      let res = await fetch(`${config.server}/v1/wxcommons/oauth2/getUUID?code=${code}`, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit'
      })
      if (res.status === 400) {
        const error = new Error()
        error.raw = res
        throw error
      }
      res = await res.json()
      window.localStorage.setItem('sdxUUID', res.data)
      // console.log('sdxUUID', res.data)
      beforeGetUserTokenByUUID(res.data)
    } catch (e) {
      redirectToAuth() // 获取uuid失败则重新进行微信授权重新获取code fe854c760b644d57baa7aa2b733ae3a0
      // window.localStorage.setItem('sdxUUID', '52f3d7e1860b4fe69fd5ea9ac63c3603') // 开发使用
      // beforeGetUserTokenByUUID('52f3d7e1860b4fe69fd5ea9ac63c3603') // 开发使用
    }
  }

  /**
   * 首先获取医院的信息，用来判断注册页面之前是否要跳转扫码页面
   */
  function beforeGetUserTokenByUUID (UUID) {
    fetch(`${config.server}/v1/hospitals/${props.match.params.hisCode}`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        // Authorization: userToken.token_type + userToken.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        UUID: UUID,
        'Accept-Language': Language.acceptLanguage
      }
    }).then((response) => response.json()).then((res) => {
      const codeArr = ['1001']
      if (res.data === 'error') {
        setIsHospitalInfo(false)
        setShowIndexPage(false)
        if (codeArr.includes(res.code)) {
          // Toast.info(res.message)
          setShowModal(true)
          setModalInfo(res.message)
          // console.log(res.message)
        } else if (res.code === '2000') {
          console.log(res.message)
        } else {
          console.log(res)
        }
      } else {
        if (!isHospitalInfo) {
          setIsHospitalInfo(true)
        }
        getUserTokenByUUID(res.data, UUID)
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据hisCode和UUID去获取用户的token
   * @param {*} hospitalData
   * @param {*} UUID
   */
  function getUserTokenByUUID (hospitalData = undefined, UUID) {
    request(`/v1/wxcommons/oauth2/token?hisCode=${props.match.params.hisCode}&uuid=${UUID}`, {
      method: 'POST',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then(async (res) => {
      if (!res.error) {
        if (res.data) {
          if (hospitalData) {
            setShowIndexPage(true)
          }
          if (!SessionContext.logged) {
            SessionContext.setLogged(true)
          }
          if (!registered) {
            setRegistered(true)
          }
          window.localStorage.setItem('sdxUserToken', JSON.stringify(res.data))
          SessionContext.setCodeExist(true)
          SessionContext.setTokenExist(true)
          // await fetchCurrentUserInfo(res.data, UUID, hospitalData)
        }
      } else {
        // console.log(res)
        if (res.code && res.code.length > 0) {
          if (Number(res.code) === 1001 || Number(res.code) === 1002) {
            window.localStorage.removeItem('sdxUserToken') // 去除与本次登录无关的用户token数据
            SessionContext.setCodeExist(true)
            SessionContext.setTokenExist(false)
            const defaultLanguage = navigator.language || navigator.userLanguage
            Language.setLocale(defaultLanguage.substring(0, 2))
            SessionContext.setCurrentUser({})
            SessionContext.setLogged(false)
            SessionContext.setBinded(false)
            setRegistered(false)
            setBinded(false)
            if (hospitalData) {
              setShowIndexPage(true)
            }
            // await getFoodAdvicesByHisCode(hospitalData)
            if (props.match.params.hisCode) {
              if (!props.match.params.patPositionId) {
                window.localStorage.removeItem('sdxPatPositionId')
                if (JSON.stringify(SessionContext.positionInfo) !== '{}') {
                  SessionContext.setPositionInfo([])
                }
                if (SessionContext.patientInfo.length !== 0) {
                  SessionContext.setPatientInfo([])
                }
              } else {
                window.localStorage.setItem('sdxPatPositionId', props.match.params.patPositionId) // 当前床位号
                // getPatientInfoByPatientBedId()
                // getAreasFloorsInfoByPatientBedId()
              }
            }
          }
        } else {
          console.log(res.message)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  // function fetchCurrentUserInfo (userToken, UUID, hospitalData) {
  //   fetch(`${config.server}/v1/orderers`, {
  //     method: 'GET',
  //     mode: 'cors',
  //     credentials: 'omit',
  //     headers: {
  //       Authorization: userToken.token_type + userToken.access_token,
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json;charset=UTF-8',
  //       'Accept-Language': Language.acceptLanguage,
  //       UUID: UUID
  //     }
  //   }).then((response) => response.json()).then(async (res) => {
  //     if (!res.error) {
  //       await SessionContext.setCurrentUser(res.data)
  //       if (res.data.language) {
  //         await Language.setLocale(res.data.language)
  //       }
  //       await getHospitalInfoByHisCode(hospitalData)
  //       if (props.match.params.hisCode) {
  //         if (!props.match.params.patPositionId) {
  //           await window.localStorage.removeItem('sdxPatPositionId')
  //           if (JSON.stringify(SessionContext.positionInfo) !== '{}') {
  //             await SessionContext.setPositionInfo({})
  //           }
  //           if (SessionContext.patientInfo.length !== 0) {
  //             await SessionContext.setPatientInfo([])
  //           }
  //         } else {
  //           await getPatientInfoByPatientBedId()
  //           await getAreasFloorsInfoByPatientBedId()
  //         }
  //       }
  //       // await SessionContext.setLogged(true)
  //       // await setRegistered(true)
  //       // await getHispitalInfo(OrderMark, sdxHisCode, Language) // 请求餐次类型，是否包伙制
  //       // await getAllFoodType(OrderMark, Language) // 请求营养餐和小锅菜的食物类型
  //       if (res.data.patientDTO === null) {
  //         SessionContext.setBinded(false)
  //         setBinded(false)
  //         // if (hospitalData.properties.isSupportScan) {
  //         //   props.history.push('/tipPage/bind')
  //         // } else {
  //         //   props.history.push('/bind')
  //         // }
  //       } else {
  //         await SessionContext.setBinded(true)
  //         await setBinded(true)
  //         // props.history.push('/order')
  //         // props.history.push('/me')
  //       }
  //     } else {
  //       // Toast.info('获取当前登录人信息失败!')
  //       setRegistered(false)
  //       setBinded(false)
  //       SessionContext.setLogged(false)
  //       SessionContext.setBinded(false)
  //       // if (window.localStorage.getItem('sdxTokens')) {
  //       //   const sdxTokens = JSON.parse(window.localStorage.getItem('sdxTokens'))
  //       //   sdxTokens[props.match.params.hisCode] = undefined
  //       //   window.localStorage.setItem('sdxTokens', JSON.stringify(sdxTokens))
  //       // }
  //       window.localStorage.removeItem('sdxUserToken')
  //       SessionContext.setCurrentUser({})
  //       if (res.message === 'invalid_token') {
  //         Toast.info('旧帐号已过期，请重新注册!')
  //       }
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }

  // /**
  //  * 根据hisCode获取医院配置信息
  //  */
  // function getHospitalInfoByHisCode (hospitalData) {
  //   getFoodAdvicesByHisCode(hospitalData)
  // }

  // /**
  //  * 根据医院的hisCode去获取医院所有的饮食医嘱
  //  */
  // function getFoodAdvicesByHisCode (basicHospitalInfo) {
  //   request(`/v1/foodadvices/hospital/${props.match.params.hisCode}`, {
  //     method: 'GET',
  //     headers: {
  //       'Accept-Language': Language.acceptLanguage
  //     }
  //   }).then(async (res) => {
  //     if (!res.error) {
  //       if (res.data.length === 0) {
  //         Toast.info('获取医院饮食医嘱为空!')
  //       }
  //       const basicInfoTemp = {}
  //       basicInfoTemp.basicHospitalInfo = basicHospitalInfo
  //       basicInfoTemp.foodAdvices = res.data
  //       await HospitalBasicInfo.setHospitalBasicInfo(basicInfoTemp)
  //       // getAreasByHisCode(basicHospitalInfo, res.data)
  //     } else {
  //       console.log(res.message)
  //       // Toast.info(res.message)
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }

  // /**
  //  * 当用户扫描床头二维码进入时，根据床位号获取病员信息
  //  */
  // function getPatientInfoByPatientBedId () {
  //   request(`/v1/patients/patposition/${props.match.params.patPositionId}?hospitalId=${props.match.params.hisCode}`, {
  //     method: 'GET',
  //     headers: {
  //       'Accept-Language': Language.acceptLanguage
  //     }
  //   }).then((res) => {
  //     if (!res.error) {
  //       if (res.data.lenght !== 0) {
  //         SessionContext.setPatientInfo([...res.data])
  //       } else {
  //         // Toast.info('根据床位号获取病员信息为空!')
  //         SessionContext.setPatientInfo([])
  //       }
  //     } else {
  //       if (res.code) { // 说明这个床位号查不到病员信息
  //         SessionContext.setPatientInfo([])
  //         if (Number(res.code) === 1001) {
  //           // setShowModal(true)
  //           // setModalInfo(intl.get('QueryPetientInfo1001'))
  //         } else if (Number(res.code) === 1002) {
  //           // setShowModal(true)
  //           // setModalInfo(intl.get('QueryPetientInfo1002'))
  //         } else if (Number(res.code) === 1003) {
  //           // setShowModal(true)
  //           // setModalInfo(intl.get('QueryPetientInfo1003'))
  //         } else {
  //           console.log(res.message)
  //         }
  //       } else {
  //         console.log(res.message)
  //       }
  //       // Toast.info(res.message)
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }

  // /**
  //  * 根据床位号获取病区，楼层信息
  //  */
  // function getAreasFloorsInfoByPatientBedId () {
  //   request(`/v1/hospitals/${props.match.params.hisCode}/lc/bq/patposition/${props.match.params.patPositionId}`, {
  //     method: 'GET',
  //     headers: {
  //       'Accept-Language': Language.acceptLanguage
  //     }
  //   }).then((res) => {
  //     if (!res.error) {
  //       if (!res.data) {
  //         SessionContext.setPositionInfo({})
  //         // Toast.info('根据床位号获取病区，楼层信息为空!')
  //       } else {
  //         SessionContext.setPositionInfo(res.data)
  //       }
  //     } else {
  //       console.log(res.message)
  //       // Toast.info('根据床位号获取病区，楼层信息失败!')
  //       // Toast.info(res.message)
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //   })
  // }

  /**
   * 点击注册按钮时触发
   */
  function handleOnRegisterClick () {
    // redirectToAuth()
    if (hospitalInfo.basicHospitalInfo) {
      if (hospitalInfo.basicHospitalInfo.properties.isSupportScan && !props.match.params.patPositionId) {
        props.history.push('/tipPage/register')
      } else {
        props.history.push('/register')
      }
    } else {
      props.history.push('/register')
    }
  }

  /**
   * 点击绑定按钮时触发
   */
  function handleOnBindClick () {
    // console.log(hospitalInfo)
    if (hospitalInfo.basicHospitalInfo) {
      if (hospitalInfo.basicHospitalInfo.properties.isSupportScan && !props.match.params.patPositionId) {
        props.history.push('/tipPage/bind')
      } else {
        props.history.push('/bind')
      }
    } else {
      props.history.push('/bind')
    }
  }

  /**
   * 点击订餐按钮时触发
   */
  function handleOnOrderClick () {
    if (isHospitalInfo) {
      props.history.push('/order')
    }
  }

  return (
    !showIndexPage ? <MyModal
      visible={showModal}
      info={modalInfo}
      cancelButtonVisible={false}
      onOkClick={() => setShowModal(false)}
    /> : <div className={showLogo?'containet-with-logo':'containet-no-logo'}>
      <div className={'divs'}>
        <div className={'div1'} />
        <div className={'div2'} />
      </div>
      <div className={'textContainer'}>
        <div className={'textChinese'}>{welcomeText}</div>
        {/* <div className={'textEnglish'}>{intl.get('Welcome')}</div> */}
      </div>
      {
        !showIndexPage ? null : <div className={'registerOrOrder'}>
          {/* <div className={'dot1'} />
          <div className={'dot2'} />
          <div className={'dot3'} />
          <div className={'dot4'} />
          <div className={'dot5'} />
          <div className={'dot6'} />
          <div className={'dot7'} /> */}
          {
            !registered ? <div onClick={() => handleOnRegisterClick()} className={'registerButtonContainer'}>
              {/* <Coffee width={30} height={30} />
              <div className={'registerText'}>{intl.get('Register')}</div> */}
              {/* <div className={'registerText'}>{intl.get('Register')}</div> */}
              {
                intl.get('Register') === '注册' ? (<img alt='' src={require('../../images/register.gif')} />) : (<img alt='' src={require('../../images/registerEnglish.gif')} />)
              }

            </div> : binded ? <div onClick={() => handleOnOrderClick()} className={'orderButtonContainer'}>
              {/* <Dinnerware width={30} height={30} />
              <div className={'orderText'}>{intl.get('OrderButtonText')}</div> */}
              {
                intl.get('OrderButtonText') === '订餐' ? (<img alt='' src={require('../../images/order.gif')} />) : (<img alt='' src={require('../../images/orderEnglish.gif')} />)
              }
              
            </div> : <div onClick={() => handleOnBindClick()} className={'bindButtonContainer'}>
              {/* <BindIcon width={30} height={30} />
              <div className={'bindText'}>{intl.get('Bind')}</div> */}

              {
                intl.get('Bind') === '绑定' ? (<img alt='' src={require('../../images/bind.gif')} />) : (<img alt='' src={require('../../images/bindEnglish.gif')} />)
              }
              
              
            </div>
          }
        </div>
      }

    </div>
  )
}
